/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import React from 'react';
import clsx from 'clsx';

export const Table = ({ children, styles }: { children: React.ReactNode; styles?: string }) => {
  return (
    <div
      className={clsx(
        styles ||
          'flex flex-col sm:flex-row sm:flex-wrap justify-between right-20 px-20 py-5 w-full bg-white z-50 overflow-x-auto'
      )}
    >
      <table className='w-full table-auto'>{children}</table>
    </div>
  );
};

export default Table;
